import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { ProductInfoModal } from 'featureSliced/widgets/Modals/ProductInfoModal'
import { useGetTranslatedNames } from '../../useGetTranslatedNames'

export type OpenProductInfoType = (product: IProduct) => void

// QRM-640: bottom sheet with the product's ingredients (declaration runs) and
// nutrient table, stacked on top of the product modal. Content is fetched lazily
// inside the sheet (GET /product-info) — the catalogue only says it exists.
export const useOpenProductInfoModal = (): OpenProductInfoType => {
  const t = useTranslations()
  const openModal = useOpenModal()
  const { getProductName } = useGetTranslatedNames()

  const openProductInfo = (product: IProduct) => {
    openModal({
      id: 'PRODUCT_INFO_SHEET',
      title: getProductName(product) || t('productInfo.title'),
      components: [
        () => (
          <ProductInfoModal
            categoryId={product.categoryId}
            productId={product.id}
            unitSellCode={product.unitSellCode}
          />
        ),
      ],
    })
  }

  return openProductInfo
}
